var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_1098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.98 10.7902V14.7902C17.9822 15.0408 17.9688 15.2913 17.94 15.5402C17.71 18.2402 16.12 19.5802 13.19 19.5802H12.79C12.6659 19.5806 12.5435 19.6097 12.4325 19.6652C12.3215 19.7207 12.2248 19.8012 12.15 19.9002L10.95 21.5002C10.8483 21.6631 10.7068 21.7973 10.5388 21.8904C10.3709 21.9835 10.182 22.0324 9.99 22.0324C9.79799 22.0324 9.60913 21.9835 9.44119 21.8904C9.27325 21.7973 9.13175 21.6631 9.03 21.5002L7.83 19.9002C7.74995 19.807 7.65212 19.7307 7.54223 19.6758C7.43234 19.6208 7.31259 19.5883 7.19 19.5802H6.79C3.6 19.5802 2 18.7902 2 14.7902V10.7902C2 7.86023 3.35 6.27023 6.04 6.04023C6.28893 6.01141 6.53941 5.99805 6.79 6.00023H13.19C16.38 6.00023 17.9767 7.59689 17.98 10.7902Z",
    stroke: "#5F5F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9791 6.79V10.79C21.9791 13.73 20.6324 15.3133 17.9391 15.54C17.9679 15.2911 17.9812 15.0406 17.9791 14.79V10.79C17.9791 7.6 16.3824 6.00333 13.1891 6H6.78906C6.53848 5.99783 6.288 6.01119 6.03906 6.04C6.26906 3.35 7.85906 2 10.7891 2H17.1891C20.3791 2 21.9757 3.59667 21.9791 6.79Z",
    stroke: "#5F5F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.49658,
    cy: 12.9766,
    r: 1.03955,
    fill: "#5F5F60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.99072,
    cy: 12.9766,
    r: 1.03955,
    fill: "#5F5F60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4849,
    cy: 12.9766,
    r: 1.03955,
    fill: "#5F5F60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_1098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChats);
export default __webpack_public_path__ + "static/media/IconChats.e7a7bef56702a4697c1b583533c3b586.svg";
export { ForwardRef as ReactComponent };